var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { string, eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import Avatar from '@philips-internal/oswald-ui-components/lib/components/avatar/avatar';
import { Card } from '@philips-internal/oswald-ui-components/lib/components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { AuthenticationService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import './patient-card.css';
import PatientCardAPI from './patient-card-api';
export var Tokens;
(function (Tokens) {
    Tokens["IE_LOGIN_TYPE"] = "ext_loginType";
    Tokens["CD_PHYSICAL_PERSON"] = "1";
})(Tokens || (Tokens = {}));
let PatientCard = class PatientCard extends Component {
    constructor() {
        super(...arguments);
        this.onClickCard = () => {
            const { onClickCard, cdPatient } = this.props;
            if (isFunction(onClickCard)) {
                onClickCard(new ClickEvent({
                    value: {
                        cdPatient
                    }
                }));
            }
        };
    }
    renderIndicator() {
        return (React.createElement("div", { className: 'c-patient-card__indicator' },
            React.createElement("div", { className: 'c-patient-card__indicator-color' })));
    }
    renderContent() {
        const { nmPhysicalPerson, fotoBase64 } = this.props;
        return (React.createElement("div", { className: "c-patient-card__avatar" },
            React.createElement(Avatar, { title: nmPhysicalPerson, image: fotoBase64 })));
    }
    renderContentPhysical() {
        const { agePatient, fotoBase64, nmPhysicalPerson, sexPatient } = this.props;
        return (React.createElement("div", { className: "c-patient-card__avatar" },
            React.createElement(Avatar, { title: nmPhysicalPerson, subtitle: sexPatient ? `${agePatient} ${MessageService.translate('result.years')} / ${this.getGender()}` : `${agePatient} ${MessageService.translate('result.years')}`, image: fotoBase64 })));
    }
    getGender() {
        const { sexPatient } = this.props;
        switch (sexPatient.toUpperCase()) {
            case 'M':
                return MessageService.translate('person.gender/m');
            case 'F':
                return MessageService.translate('person.gender/f');
            default:
                return MessageService.translate('person.gender/i');
        }
    }
    render() {
        const token = AuthenticationService.getJWTToken();
        let ieLoginType = '';
        if (token) {
            ieLoginType = token.claims[Tokens.IE_LOGIN_TYPE];
        }
        return (React.createElement(Card, { width: 12, className: 'c-patient-card', onClick: () => this.onClickCard(), selectionType: SelectionType.SINGLE, uuid: "952f28df-cefa-4116-b8b8-84639c7d4136" },
            this.renderIndicator(),
            React.createElement("div", { className: 'c-patient-card__wrapper' },
                ieLoginType === Tokens.CD_PHYSICAL_PERSON &&
                    this.renderContentPhysical(),
                ieLoginType !== Tokens.CD_PHYSICAL_PERSON &&
                    this.renderContent())));
    }
};
PatientCard.propTypes = {
    agePatient: string,
    cdPatient: string,
    fotoBase64: string,
    nmPhysicalPerson: string,
    onClickCard: eventListener,
    sexPatient: string,
};
PatientCard = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: PatientCardAPI })
], PatientCard);
export default PatientCard;
//# sourceMappingURL=patient-card.js.map